/* eslint-disable camelcase */
import { createI18n } from 'vue-i18n'

const messages = {
  en: {
    common: {
      close: 'Close',
      cancel: 'Cancel',
      saving: 'Saving...',
      change: 'Change',
      secure: 'Secure',
      protected: 'Protected',
      secure_payment: 'Secure Payment',
      back: 'Back',
      withdraw: 'Battery Withdrawal',
      rental: 'Active Rental',
      checkout: 'Checkout',
      summary: 'Summary'
    },
    menu: {
      toggle: 'Toggle menu'
    },
    confirm_account: {
      welcome: 'Account confirmation',
      confirmation_successful: 'Your account has succesfuly confirmed',
      confirmation_failed: 'An error ocurred in your account confirmation',
      waiting: 'Waiting for account confirmation...',
      unspected_error: 'Unspected error occurred'
    },
    login: {
      battery_almost_over: 'BATTERY ALMOST OVER?!',
      fast_login: 'LOG IN FOR QUICK RENT',
      or: 'OR',
      create_account: 'CREATE NEW ACCOUNT',
      sign_in_or_create: 'Log in or Create Account',
      sign_in: 'Log in with your account',
      sign_in_button: 'Login',
      email_address: 'Email Address',
      password: 'Password',
      forgot_password: 'Forgot Password?',
      dont_have_account: "Don't have an account?",
      register_email: 'Sing up with email',
      register_social: 'Sing up with social network',
      register_with_email: 'Access with email',
      login_with_code: 'Already have a code?',
      click_here: 'Click Here!',
      facebook_btn_text: 'Continue with Facebook',
      locale: 'en_US',
      whatsapp_msg: 'https://api.whatsapp.com/send/?phone=5521998445033&text=Hi!%20I%20need%20help%20-%20E2G',
      find_us: 'Find other spots',
      title_rent: 'RENT A POWER BANK',
      verify_mail: '*Check your inbox mail for the code. If not found, check on the spam folder',
      validate: 'Validate',
      resend_email: 'Resend email',
      rent_info: 'Rent{pointName} and return at any Energy2Go station.',
      rent_info_free_hourly_daily: 'Rent{pointName} with {freeTime} free. Return at any Energy2Go station.',
      rent_info_hourly_daily: 'Rent{pointName}: first {hourlyTime} for {hourlyPrice}. Return at any Energy2Go station.',
      rent_info_free_daily: 'Rent{pointName} with {freeTime} free. Return at any Energy2Go station.',
      rent_info_daily: 'Rent{pointName}: daily rates of {dailyPrice} (24h). Return at any Energy2Go station.',
      rent_info_free_hourly: 'Rent{pointName} with {freeTime} free. Return at any Energy2Go station.',
      rent_info_hourly: 'Rent{pointName}: first {hourlyTime} for {hourlyPrice}. Return at any Energy2Go station.'
    },
    sign_up: {
      submit: 'Access',
      sign_up: 'Email Access',
      email_address: 'Email',
      password: 'Password',
      password_confirmation: 'Password Confirmation',
      agree_user_terms: ' I agree with the user terms',
      type_email: 'Type your email',
      user_terms: 'User terms',
      already_have_account: 'Already have an account with your email?',
      already_have_social_account: 'Sing up with social network',
      mandatory_user_terms: 'You must agree with the user terms',
      password_doesnt_match: 'The password confirmation does not match the password',
      invalid_email: 'Invalid email',
      required_email: 'Email is required',
      email_verification: 'Verify your email to access your account. If not found, check on the spam folder',
      title_open_mail_modal: 'Validation'
    },
    forgot_password: {
      forgot_password: 'Forgot Password?',
      email: 'Email',
      remember: 'Submit',
      success: 'We have sent you an email with a link to reset your password',
      failed: 'We could not find a user with this email address',
      redirect_msg: 'You will be redirected to the login page in 5 seconds',
      invalid_email: 'Invalid email',
      required_email: 'Email is required'
    },
    map: {
      place_open: 'Open',
      place_closed: 'Closed',
      available_bateries: 'available bateries',
      available_slots: 'available slots',
      close_hour: 'Closes at',
      open_hour: 'Opens at',
      hour: 'en',
      my_location: 'My Location',
      phone: 'SMARTPHONE',
      ebike: 'E-BIKE',
      all: 'ALL',
      terminal_type: 'Terminals for: '
    },
    map_navigation: {
      title: 'Exchange Points',
      close: 'Close',
      back: 'Back',
      withdraw_battery: 'Withdraw Battery',
      select_station: 'Select Station',
      select_terminal: 'Select Terminal',
      available_batteries: 'available batteries',
      available_slots: 'available slots',
      available_slots_return: 'available slots for return',
      location_denied: 'Location permission denied',
      loading: 'Loading map...',
      terminal_token: 'Terminal Token',
      scan_qr_code: 'Scan QR Code',
      check_prices: 'Check Prices',
      low_stock: 'Low stock',
      copied: 'Copied!',
      no_batteries: 'No batteries available',
      error_title: 'Error loading map',
      error_message: 'An error occurred while loading the collection points.',
      retry: 'Try again',
      no_points: 'No points available',
      no_points_message: 'There are no collection points available in this region.',
      location_modal_title: 'Enable Location Access',
      location_modal_description: 'We need your location to improve navigation and show you the closest terminals.',
      location_modal_subtitle: 'Your privacy is important. We only use your location to enhance your experience.',
      location_modal_allow: 'Allow Location Access',
      location_modal_skip: 'Skip for Now',
      permission_blocked_title: 'Location Permission Blocked',
      permission_blocked_description:
        'You have denied location access multiple times. To enable it again, you need to reset the permission in your browser settings.',
      permission_blocked_instructions:
        'Click the lock icon next to the URL bar, find "Location" and change it from "Block" to "Ask".',
      permission_blocked_ok: 'I understand',
      manual_token_title: 'Rent battery with code',
      manual_token_description: 'Enter the 4-digit code located near the QR Code.',
      token_placeholder: '####',
      token_invalid_length: 'Token must have 4 characters',
      token_not_found: 'Token not found. Please check and try again.',
      no_batteries_available: 'This terminal has no batteries available',
      station_name: 'Station',
      address: 'Address',
      terminal_offline: 'Terminal Offline',
      retry_location: 'Enable Location',
      minimize: 'Minimize',
      show_token_input: 'Show Token Input',
      manual_token_input: 'Type code',
      enter_token: 'Enter Token',
      enter_token_manually: 'Enter Token Manually',
      far_from_terminal_title: 'You are {distance} km away from this terminal',
      far_from_terminal_confirm: 'Are you sure you want to continue?',
      continue: 'Continue',
      cancel: 'Cancel',
      return_battery: 'Return Battery',
      return_here: 'Return Here',
      rent_here: 'Rent Here',
      no_slots: 'No slots available',
      validation_error_title: 'Choose the terminal again',
      validation_error_close: 'Close',
      validation_error_terminal_info: 'Terminal Information',
      validation_error_available_cables: 'Available Cable Types at This Terminal',
      validation_error_try_different_cable: 'Select Different Cable Type',
      validation_error_generic: 'Error validating terminal',
      payment_error_title: 'Payment Error',
      payment_error_message:
        'An error occurred while processing your payment. Please try again or select another payment method.',
      terminal_selection_error: 'Unable to select terminal. Please try again.',
      generic_error_message: 'An unexpected error occurred. Please try again.',
      error_terminal_offline_title: 'Terminal Offline',
      error_terminal_offline_message:
        'This terminal is temporarily offline. Please try again in a few moments or select another terminal.',
      error_retry: 'Try Again',
      error_choose_another: 'Choose Another Terminal',
      error_choose_another_pay: 'Choose Another Payment Method',
      error_no_cable_title: 'Cable Not Available',
      error_no_cable_message:
        'Please select an available cable from the options below or return a battery with a cable before renting another.',
      error_no_charged_title: 'No Charged Batteries',
      error_no_charged_message: 'This terminal does not have fully charged batteries at the moment.',
      error_transaction_expired: 'The time limit expired.',
      error_back_to_map: 'Back to Map',
      address_not_available: 'Address not available',
      error_nearby_terminals_title: 'Nearby Terminals with Batteries',
      error_nearby_terminal_distance: '{distance}m away',
      error_select_terminal: 'Select This Terminal',
      error_validating_token: 'Error validating token',
      error_back_to_token: 'Back to Enter Code',
      error_choose_another_battery: 'Choose Another Battery',
      validation_timeout: 'Validation timeout - please try again',
      cable_switch_title: 'Choose Another Cable',
      cable_switch_message:
        'This terminal has batteries available with different cable types. Just select the one that fits your device!',
      select_cable: 'Select your cable type:',
      select_cable_to_continue: 'Select your cable type:',
      confirm_cable_selection: 'Confirm Selection',
      validating: 'Validating...',
      payment_verification: 'Payment Verification',
      payment_error_message:
        'An error occurred while processing your payment. Please try again or select another payment method.',
      checking_payment: 'Checking payment method',
      validating_terminal: 'Validating terminal and checking availability',
      checkout: 'Complete Checkout',
      checkout_verify_title: 'Check the rental price and conditions',
      waiting_gps_signal: 'Searching for GPS signal...',
      gps_acquired: 'Location found',
      center_on_me: 'Center on my location',
      my_location: 'My Location',
      locating_gps: 'Searching for location...',
      enable_location: 'Enable location',
      refresh_points: 'Refresh Points'
    },
    select_payment_method: {
      title: 'Choose Payment Method',
      subtitle: 'Select the payment method you want to use:',
      choose_method: 'Choose your payment method',
      pix_description: 'Instant and secure',
      card_title: 'Credit Card',
      card_description: 'Convenient and safe',
      type_1: 'Credit',
      type_2: 'Pix',
      back: 'BACK',
      register: 'REGISTER',
      register_credit_card: 'CREDIT CARD',
      register_pix: 'REGISTER PIX',
      deposit: 'A security deposit will be charged',
      credit: '(credit)',
      change: 'Change payment method already registered:',
      modify: 'MODIFY'
    },
    checkout: {
      summary_title: 'Transaction Summary',
      point: 'Station',
      cable: 'Cable',
      amount: 'Amount',
      payment_method: 'Payment',
      pix_scan_or_copy: 'Scan the QR Code or copy the PIX key',
      generating_qr_code: 'Generating QR Code...',
      pix_copy_paste_key: 'PIX Copy and Paste',
      waiting_payment: 'Waiting for payment confirmation...',
      card_will_be_charged: 'Your credit card will be charged',
      processing: 'Processing...',
      confirm_payment: 'Confirm Payment',
      credit_card: 'Credit Card',
      pricing_simulation: 'Charging Simulation',
      view_other_prices: 'View other prices',
      amount_to_pay: 'Amount to pay',
      for_period: 'for {period}',
      pix_error_generating: 'Error generating PIX QR Code. Please try again.',
      pix_important_info: 'Important Information',
      pix_return_to_website:
        'After completing the PIX payment, you will be redirected to the website to confirm the transaction. Keep this code open.',
      deposit: 'Security Deposit',
      deposit_title: 'Guarantee Security Deposit',
      deposit_message:
        'A security deposit of R$ 99.90 will be held as a guarantee while you have the battery. This will be returned upon your next return.',
      deposit_agreement: 'I agree to the security deposit',
      deposit_agreement_required: 'You must accept the security deposit to continue',
      find_return_points: 'Find return points on the map',
      payment_confirmed: 'Payment Confirmed!',
      confirm_withdrawal: 'Confirm Withdrawal',
      confirm_free_withdrawal: 'CONFIRM FREE WITHDRAWAL*',
      confirm_withdrawal_without_free_time: 'CONFIRM WITHDRAWAL WITHOUT FREE TIME*',
      take_battery: 'Take Battery',
      pix_generation_info: 'To pay with PIX, you need to generate a QR Code.',
      pix_registration_required: 'To pay with PIX, you must register your Name and CPF/CNPJ.',
      register_pix: 'Register PIX details',
      pix_expiring_soon: 'QR Code expires in moments',
      pix_expiring_warning: 'QR Code expires soon',
      pix_expires_in: 'Your PIX expires in',
      pix_qr_expired: 'QR Code expired',
      pix_qr_expired_message: 'The payment time has expired. Generate a new QR Code to continue.',
      pix_generate_new_qr: 'Generate new QR Code',
      promo_benefit_badge: '*Free Benefit',
      promo_free_activated: 'Free time activated',
      promo_not_activated: 'Free time disabled',
      promo_asterisk_note: '*Required to apply the free promotional period (Free*) shown above.'
    },
    home: {
      take: {
        add_card: 'REGISTER YOUR CARD',
        no_charge: 'Register a valid credit card to rent power banks. Your card will be stored by Cielo.',
        ssl: 'Secure connection',
        card_number: 'Credit Card Number',
        valid_through: 'Valid Through',
        name: 'Name on card',
        save_credit_card: 'SAVE CREDIT CARD DATA',
        take_title: 'Select cable type',
        cable_type: 'Choose the Cable Type',
        qr_code_title_1: 'Select the Energy2go Terminal',
        qr_code_title_2: 'Locate the QR Code in the terminal',
        qr_code_text: 'Scan the 4 digits below the QR code located in front of the terminal:',
        scan_qr: 'Scan',
        scan_qr2: 'QR code',
        type_token: 'Or enter the Token Located on Terminal Display',
        terminal_token: '####',
        take_battery: 'Take Battery',
        agreed: 'By renting a powerbank, you agree to the applicable rates: ',
        price_table: 'Price Table',
        credit_cards: 'CREDIT CARDS',
        manage: 'Manage your payment methods',
        standard: 'Standard',
        delete: '',
        delete_title: 'Delete Credit Card',
        delete_text: 'Delete card ending in ',
        delete_cable_title: 'Delete Cable',
        cancel: 'CANCEL',
        confirm: 'REMOVE BATTERY',
        checkout: 'OK',
        liberate_battery: 'LIBERATE BATTERY',
        need_help: 'Contact Us for Events',
        selected_card: 'Your the card',
        standard_title: 'Standard Credit Card',
        standard_text: 'Set as Standard the credit card ending in ',
        set_standart_credit_card_not_possible:
          'An error occurred while updating the default payment method. Please try again',
        slot: 'PUSH, then PULL the battery indicated by the blinking LED',
        charger: "Charger's App must be indicating that the battery is ready to go",
        verify_terminal: 'Checking Terminal',
        register_card: 'Registering Credit Card',
        credit_reservation_1: 'A reservation of ',
        credit_reservation_2:
          ' will be held on your credit card. In some cases, when free time is offered we will free your credit card hold if you return the battery before the end of this free time.',
        dont_ask: "Don't ask again",
        campaign: '*I want my free time (I agree to receive sponsor updates)',
        no_free: 'Rent without the sponsored free time',
        update: 'Updating Permissions',
        on_demand: 'RENT ON DEMAND',
        subscription: 'SUBSCRIPTION PLANS',
        understand: 'I UNDERSTOOD',
        free_time_title: 'Next Rent',
        free: 'free',
        sponsored_by: 'Sponsored By',
        at: 'at',
        only_at: "To access all Terminal's Location, ",
        click_here: 'click here!',
        other_terminals: 'Find other terminals',
        logout: 'Logout',
        history: 'History',
        logout_2: 'LOGOUT',
        payment_methods: 'Payment Methods',
        home: 'Home',
        renew: 'Renew ',
        events: 'CONTACT US FOR EVENTS',
        maps_menu: 'Terminals Map',
        here: 'here',
        table_footnote:
          '*You are renting only one power bank and its energy may not be available for the whole renting time.',
        table_footnote_2_1: '** For payments via PIX, a security deposit of ',
        table_footnote_2_2:
          'reais is required. Upon return, the amount is partially refunded according to the prices above.',
        by: ' by ',
        table_title: 'Charged Values',
        of: ' of ',
        text_table_redraw: 'Withdraw your power bank at:',
        text_table_parks: 'Parks and Stadiums and Bossa Nova Mall and Balneário Shopping:',
        qr_scan_fail: 'Token not found, please scan again or enter the token manually.',
        qr_scan_fail_backend: 'Null token, QR code reading failed',
        text_table_charges_only: '- Charged only ',
        text_table_other_locations: 'Other locations:',
        text_table_ischarged: '- Charged ',
        text_table_after_period: 'After this period is charged ',
        text_table_stay: ' of stay with the battery. ',
        feedback_thanks: 'THANKS FOR THE RESPONSE!',
        close: 'Close',
        send: 'SEND',
        skip: 'SKIP',
        what_happened: 'What happened?',
        customer_response_1: "I didn't know which battery to remove.",
        customer_response_2: "I tried pulling it out, but the battery wouldn't come out.",
        customer_response_3: 'I gave up on removing the battery',
        battery_not_removed: 'Battery was not removed.',
        inform_token: 'Token must be informed.',
        token_contain: 'Token must contain only numbers or only letters.',
        token_size: 'Token must contain 4 numbers or letters.',
        user_card: 'Credit Card:',
        card_ending: 'Last digits:',
        terminal_offline_title: 'TERMINAL OFFLINE',
        terminal_offline_text: 'The terminal is offline, the battery cannot be removed.',
        error_procession: 'You declined the credit reservation, battery not removed',
        confirm_cancel_operation: 'Are you sure you want to cancel this operation?',
        user_cancelled_transaction: 'User cancelled the transaction',
        fail_take_battery: 'Failed to take battery',
        transaction_failed: 'Transaction failed',
        fail_verify_terminal: 'Failed to verify terminal',
        fail_server_communication: 'Failed to communicate with server'
      },
      demonstration: {
        title: 'Take the battery',
        text_1: 'PULL OUT',
        text_2: ' the battery as shown in the figure.',
        error_slot_missing: 'Slot information is not available. Please try again.',
        error_slot_invalid: 'Invalid slot number. Please try again.'
      },
      return: {
        success: 'Use instructions',
        fail_title: 'BATTERY NOT REMOVED',
        fail_text: 'The battery was not removed.',
        instructions: 'Detach the cables and press the button to charge',
        free_time: 'Free Time Remaining',
        free_time_over: 'Your free time is up! Please return the battery to any of our terminals.',
        time: 'Time using battery',
        price: 'Current Price',
        check_out: 'I want to see the',
        price_table: 'Price List',
        error_title: 'Error',
        error_message: 'An error occurred during the transaction.',
        map_1: 'See in the',
        link_map: 'Map',
        map_2: ' the points for returning the battery',
        faqs: {
          title: 'Need help?',
          were_to_return: {
            title: 'Where can I return the battery?',
            html_1: 'See',
            html_2: 'the available points',
            html_3: 'and the availability of empty slots for return.'
          },
          not_charge: {
            title: 'The battery does not charge my device',
            step_1: 'Verify that the battery cable is correctly connected to the device.',
            step_2: 'Click on the button at the bottom of the battery to force it to charge.',
            step_3: 'You can return the battery in less than 5 minutes to receive an automatic refund.',
            step_4:
              'If you have another battery, make another rental, as this battery will be ignored in the next rental.'
          },
          how_to_return: {
            title: 'How to return the battery?',
            step_1: 'Place the connectors back on the sides of the battery.',
            step_2: 'Insert the battery with the logo facing up into any slot of the kiosk until it locks.',
            step_3: 'Check if the battery is properly locked.',
            step_4: 'Wait for the blue light on the slot to turn on.',
            step_5: 'The site will update, and the transaction will be completed.'
          },
          return_failed: {
            title: 'I returned it, but the transaction did not finish',
            html_1: 'If the transaction did not finish, please contact us via ',
            html_2: 'https://api.whatsapp.com/send/?phone=5521998445033&text=Hi!%20I%20need%20help%20-%20E2G',
            html_3: 'WhatsApp'
          }
        }
      }
    },
    history: {
      back: 'BACK',
      rent: 'Rental History',
      subtitle: 'Track your rentals and returns',
      summary: '{count} rentals found',
      transaction: 'Rental',
      status_pending: 'In progress',
      status_completed: 'Completed',
      taken_at: 'Taken at',
      returned_at: 'Returned at',
      pending_return: 'Return pending',
      plan: 'Plan: ',
      load_more: 'Load More',
      no_transactions: 'No transactions found yet',
      empty_hint: 'When you rent a battery, it will appear here.',

      // Transaction status labels
      status_2: 'Reserved',
      status_15: 'Unknown',
      status_17: 'Returned Unlocked',
      status_19: 'Validated',

      // Payment status labels
      payment_status_1: 'Payment Pending',
      payment_status_2: 'Authorized',
      payment_status_3: 'Captured',
      payment_status_4: 'Payment Completed',
      payment_status_5: 'Payment Failed',
      payment_status_6: 'Refunded',
      payment_status_7: 'Cancelled',

      // Pre-payment status labels
      pre_payment_status_1: 'Pre-payment Pending',
      pre_payment_status_2: 'Approved',
      pre_payment_status_3: 'Processing',
      pre_payment_status_4: 'Pre-payment Failed',
      pre_payment_status_5: 'Pre-payment Cancelled',
      pre_payment_status_6: 'Refunded',
      pre_payment_status_11: 'Authorized',

      // Refund information
      refund_info: 'Refund Information',
      deposit_held: 'Security Deposit',
      amount_charged: 'Amount Charged',
      amount_refunded: 'Amount Refunded',
      refunded_badge: 'Refunded',
      status_timeline: 'Transaction Timeline',
      transaction_history: 'Transaction History'
    },
    price_table: {
      title: 'Price inquiry',
      title_2: ' at the terminal',
      text: 'Pick up your battery by:',
      text_2: 'During the time the battery is with you, daily charges of',
      text_3: ' up to the limit of ',
      text_4: 'PIX deposit (guarantee):',
      text_4_2: 'Deposit (guarantee):',
      text_5: 'will be applied as a guarantee while you have the battery.',
      text_6: 'to see the specific billing information for the point.',
      until: 'Until',
      first: 'First',
      campaign_first_hours: 'Campaign first',
      campaign_first_minutes: 'Campaign first',
      after_free: 'Next {duration}',
      first_period: 'First {duration}',
      after_hourly: 'After that (daily 24h)',
      after_free_daily: 'After that (daily 24h)',
      daily_only: 'Daily (24h)',
      hours: 'h',
      minutes: 'minutes',
      minutes_short: 'min',
      link: 'Select an Energy2Go terminal',
      back: 'BACK',
      warning: 'Log in and select an Energy2Go point',
      free: 'Free',
      free_star: 'Free*',
      help_text_find_token: 'Locate the QR Code in front of the terminal',
      help_text_digits: 'Enter the 4 numeric digits below',
      insert_token: 'token',
      token_not_found: 'Entered token not found. Please check and try again.',
      consult: 'QUERY',
      new_consult: 'NEW QUERY',
      obs1: 'Quantity: Value for the rental of 1 portable battery',
      obs2: 'Billing: Periods and daily rates are charged in full (no fraction)',
      obs3: 'Battery life: The battery charge may not last the entire rental period',
      obs4: 'Promotion: Sponsored offer. Check conditions when requesting',
      obs5: 'PIX Deposit: Security hold of {deposit}, refunded upon return'
    },
    token_selection: {
      main_text: 'Rent Location',
      button_text: 'SELECT',
      local: 'Local',
      current: 'Current',
      address: 'Address',
      view_on_map: 'VIEW ON MAP',
      view_map: 'VIEW MAP',
      retry: 'RETRY',
      confirm: 'CONFIRM',
      back: 'BACK',
      next_point: 'Energy2Go Stations near you:',
      go_to_map: 'Or view other Energy2Go Terminals on map:',
      go_to_map_2: 'View all Energy2Go Stations',
      choose_other_terminal_1: 'You are renting at a different location?',
      choose_other_terminal_2: 'Enter another token',
      choose_other_terminal: 'Renting at a different location? Enter another token',
      generic_error: 'It was not possible to communicate with the station. Please try again in a moment',
      share_location_2: 'Touch to share.',
      qr_scanner_instruction: 'Point to the QR Code at the top of the station to identify the rental place',
      press_to_scan: 'Press to scan >',
      location_distant_warning: 'You seem to be distant from the selected station',
      qr_code_location_question: 'Where is the QR Code?',
      qr_code_location_title: 'QR Code Location',
      qr_code_location_description:
        'The QR Code is located at the top of the Energy2go station. Point your phone camera at the code to identify the rental place.',
      qr_code_location_alt: 'QR Code location at Energy2go station',
      qr_code_image_unavailable: 'Image not available',
      insert_token: 'Or manually enter the terminal token:',
      proceed_text: 'You selected the Energy2Go Station {token_input} located at: {newPointName}.',
      retry_same: 'Try again at the same Energy2Go Station:',
      view_location: 'View location on map',
      share_location_1: 'Share your location to increase the transaction security.',
      touch_to_confirm: 'Tap to confirm',
      touch_to_change: 'Tap to change',
      location_far: 'You are far from the selected station {token_input}.'
    },
    rent_processing: {
      start: {
        text: 'Starting battery rental'
      },
      verify: {
        text: 'Verifying battery station'
      },
      cancel: {
        text: 'Rent cancelled by user, due to distance from terminal',
        button: 'UNDERSTOOD'
      },
      payment: {
        text: 'Processing transaction'
      },
      error: {
        title: 'Error',
        text: 'Error to remove battery'
      },
      campaign: {
        cancel_button: 'RENT WITHOUT FREE',
        confirm_button: 'USE FREE TIME'
      },
      confirmation: {
        text: 'Do you want to confirm the battery removal with the options below?',
        cancel_confirmation: 'Are you sure you want to cancel the battery removal?',
        cancel: 'The security deposit will be refunded in 10 minutes or less'
      },
      pix_confirmation: {
        title: 'PAYMENT WITH PIX',
        text: 'Payment information',
        confirm: 'NEXT',
        back: 'BACK'
      },
      success: {
        text: 'Battery removed successfully'
      }
    },
    evaluation_box: {
      text: 'Thank you for your response. Try again',
      text_2: 'Thank you for your response.'
    },
    evaluation_dialog: {
      success_title: 'Evaluation Submitted',
      success_message: 'Thank you for your feedback!',
      close_button: 'Close',
      question_what_problem: 'What was the problem?',
      button_submit: 'Submit Evaluation',
      button_cancel: 'Cancel',
      submit_fail: 'Failed to submit evaluation'
    },
    failed_dialog: {
      title_battery_not_removed: 'Battery was not removed',
      subtitle: 'An error occurred while removing the battery',
      automatic_refund_message: 'Automatic refund in',
      automatic_refund: 'Time remaining for automatic refund',
      try_again: 'Try Again',
      refund: 'Request Refund',
      skip: 'Skip',
      button_try_again: 'TRY AGAIN',
      button_refund: 'Refund',
      button_skip: 'Skip',
      message_retry_failed: 'Failed to try again',
      message_refund_successful: 'Refund completed successfully',
      message_refund_failed: 'Refund failed',
      retry_fail: 'Retry attempt failed',
      refund_success: 'Refund completed successfully',
      refund_fail: 'Refund process failed',
      refund_requested_title: 'Refund Requested',
      refund_requested_message: 'Your refund has been successfully requested and will be processed soon.',
      close_button: 'CLOSE',
      question_what_problem: 'What was the problem?',
      subtitle_safe_balance: "Don't worry, your balance is safe.",
      button_refund_now: 'REFUND NOW',
      refund_confirmation_title: 'Confirm Refund',
      refund_confirmation_message: 'Are you sure you want to request a refund? This action cannot be undone.',
      button_confirm_refund: 'CONFIRM REFUND',
      button_cancel_refund: 'CANCEL',
      automatic_refund_success_message: 'Refund requested automatically. Time has expired.'
    },
    refund_modal: {
      title_scheduled: 'Refund Scheduled',
      title_completed: 'Refund Completed',
      message_scheduled_pix:
        'Your Pix deposit refund has been scheduled and will be credited to your original bank account shortly.',
      message_completed_pix:
        'Your Pix deposit refund has been completed successfully and credited to your original bank account.',
      message_scheduled_card:
        'The card reservation cancellation/refund has been scheduled and will be processed by your card issuer.',
      message_completed_card: 'The credit card reservation cancellation/refund has been confirmed successfully.',
      message_scheduled_generic:
        'Your refund has been successfully requested and will be processed asynchronously shortly.',
      message_completed_generic: 'Your refund has been completed successfully.',
      automatic_notice: 'Refund requested automatically after withdrawal timeout.',
      async_notice: 'The refund is processed asynchronously by the system.',
      button_close: 'GOT IT'
    },
    error_modal: {
      // General titles and messages
      generic_error_title: 'Unexpected Error',
      generic_error_message: 'A problem occurred. Please try again or contact support.',
      generic_hint: 'Something went wrong.',
      validation_error_title: 'Validation Error',
      validation_error_message: 'The provided data is invalid. Please check and try again.',

      // Terminal-specific errors
      terminal_offline_title: 'Terminal Offline',
      terminal_offline_message:
        'This terminal is temporarily unavailable. Please try again in a few moments or select another terminal.',

      // Battery/cable errors
      no_cable_title: 'Cable Not Available',
      no_cable_message: 'There are no batteries with the selected cable type at this terminal.',
      no_charged_title: 'No Charged Batteries',
      no_charged_message: 'This terminal has no charged batteries available at the moment.',

      // Token errors
      invalid_token_title: 'Invalid QR Code',
      invalid_token_message: 'The scanned QR Code is not valid. Please make sure you are scanning the correct code.',
      terminal_not_found_title: 'Terminal Not Found',
      terminal_not_found_message: 'The entered code does not correspond to any terminal.',

      // Payment errors
      no_payment_title: 'Payment Method Required',
      no_payment_message: 'A payment method must be registered to continue.',

      // Registration/login errors
      email_exists_title: 'Email Already Registered',
      email_exists_message: 'This email is already registered on our platform.',
      invalid_code_title: 'Invalid Validation Code',
      invalid_code_message: 'The provided code is invalid or has expired.',

      // Actions/buttons
      close: 'Close',
      try_again: 'Try Again',
      scan_again: 'Scan Again',
      change_cable: 'Change Cable Type',
      select_another_terminal: 'Select Another Terminal',
      error_back_to_token: 'Back to Enter Code',
      error_choose_another_battery: 'Choose Another Battery',
      add_payment: 'Add Payment',
      login: 'Login',
      forgot_password: 'Forgot Password',
      resend_code: 'Resend Code',
      contact_support: 'Contact Support',

      // Auxiliary sections
      show_details: 'Show Details',
      need_help: 'Need help?'
    },
    default_tile: {
      credit_card: {
        exclude: 'EXCLUDE'
      }
    },
    manage_payment: {
      title: 'Manage Payment Methods',
      subtitle: 'Select default payment',
      confirm_remove: 'Confirm remove payment method?',
      removing: 'Removing payment method...',
      dismiss: 'SELECT',
      card: {
        title: 'Payment method: Credit'
      },
      pix: {
        title: 'Payment method: PIX'
      },
      none: {
        title: 'Payment',
        subtitle: 'Payment method: PIX or Credit'
      },
      empty_state: "You don't have any payment methods registered yet.",
      disable_delete_rental_in_progress: 'Payment methods cannot be deleted during an active rental.'
    },
    credit_card_registration: {
      button: 'SAVE CARD DATA',
      card_number: 'Card Number',
      expiry_date: 'Expiry Date',
      cardholder_name: 'Cardholder Name',
      cardholder_name_placeholder: 'NAME ON CARD',
      pix_registration: 'REGISTER PIX DATA',
      errors: {
        number_required: 'Card number is required',
        number_invalid: 'Invalid card number',
        expiry_required: 'Expiry date is required',
        expiry_invalid: 'Invalid date',
        month_invalid: 'Invalid month',
        card_expired: 'Card expired',
        cvv_required: 'CVV is required',
        cvv_invalid: 'Invalid CVV',
        name_required: 'Cardholder name is required',
        name_complete: 'Full name is required',
        register_error: 'Error registering card',
        register_error_retry: 'Error registering card. Please try again.'
      }
    },
    pix_payment: {
      title: 'PAY WITH PIX',
      title_2: 'ADD BALANCE',
      loading: 'Loading QR Code for payment...',
      create_pix: 'GENERATE QR CODE',
      create_pix_opt_in: '(USING FREE TIME)',
      create_pix_opt_out: '(WITHOUT FREE TIME)',
      info: "Don't worry! You will only pay the rental amount.",
      text_1: 'A payment of',
      text_2: 'will be made as a rental guarantee.',
      warning: 'Make the payment and <b>return here</b> to continue with the rental.',
      refund: 'The remaining amount will be refunded after the battery is returned, in accordance with the ',
      price_table: 'Price Table',
      try_again: 'Try generate QR Code again',
      change_payment: 'Change payment method',
      cancel: 'Cancel',
      pre_price_table: 'See values in the ',
      post_price_table: ' after this period',
      view_pix: 'View QR Code'
    },
    credit_card_payment: {
      title: 'Rent Battery',
      loading: 'Loading QR Code for payment...',
      create_pix: 'RENT BATTERY',
      create_pix_opt_in: '(USING FREE TIME)',
      create_pix_opt_out: '(WITHOUT FREE TIME)',
      info: "Don't worry! You will only pay the rental amount.",
      text_1: 'A payment of',
      text_2: 'will be made as a rental guarantee.',
      warning: 'Make the payment and <b>return here</b> to continue with the rental.',
      refund: 'The remaining amount will be refunded after the battery is returned, in accordance with the ',
      price_table: 'price table',
      try_again: 'Try generate QR Code again',
      change_payment: 'Change payment method',
      cancel: 'Cancel',
      agree: 'By removing the battery you will agree with the values in the ',
      link_map: 'Need return in another place? Find in the ',
      map: 'map',
      summary_title: 'Summary & Values',
      see_other_prices: 'see other prices',
      label_location: 'Location:',
      label_connector: 'Connector:',
      label_payment: 'Payment:',
      deposit_charge: 'A charge of {deposit} will be held as security deposit',
      deposit_subtitle: 'Total automatically adjusted at the end of the rental.',
      confirm_with_free: 'CONFIRM RENTAL',
      confirm_without_free: 'CONFIRM RENTAL WITHOUT FREE TIME',
      per_unit_hourly: 'per 4 hours',
      per_unit_daily: 'per day',
      per_unit_battery: 'per battery',
      payment_card: 'Credit Card',
      payment_pix: 'Pix',
      payment_not_applied: 'Payment not applied',
      payment_on_demand: 'On-demand payment',
      payment_unknown: 'Unknown payment method',
      return_other_place: 'Need to return somewhere else? View stations on the ',
      map_link: 'map',
      free: 'Free*',
      rental_value_label: 'RENTAL VALUE'
    },
    pix_registration: {
      title: 'REGISTER YOUR PIX DATA',
      subtitle: 'Register your Pix details to rent power banks',
      button: 'SAVE PIX DATA',
      back: 'BACK',
      credit_card_registration: 'REGISTER CREDIT CARD DATA',
      full_name: 'Full Name',
      errors: {
        name_required: 'Full name is required',
        name_complete: 'Name must be complete',
        cpf_cnpj_required: 'CPF/CNPJ is required',
        cpf_invalid: 'Invalid CPF',
        cnpj_invalid: 'Invalid CNPJ',
        cpf_cnpj_invalid_length: 'CPF/CNPJ with invalid length',
        register_error: 'Error registering PIX identification',
        register_error_retry: 'Error registering PIX identification. Please try again.'
      }
    },
    cable_type: {
      mini_box: {
        cable_title: '(built-in)'
      },
      subtitle: 'Cables are already built into the sides of the battery',
      connector: 'SELECT YOUR DEVICE CONNECTOR',
      options: {
        lightning: {
          labelName: 'Apple Lightning',
          labelLine: 'iPhone 14 and earlier versions'
        },
        usbc: {
          labelName: 'USB-C',
          labelLine: 'Android devices (e.g.: Samsung, Motorola, Xiaomi), Apple iPhone 15 and posterior versions'
        },
        micro: {
          labelName: 'Micro USB',
          labelLine: 'Older Android devices, speaker boxes and headphones'
        }
      }
    },
    rating_transaction: {
      title: 'Rate the battery rental in ',
      send: 'SEND',
      feedback: 'Rate the rental (optional)'
    },
    transaction_info: {
      title: 'Battery Returned Successfully!',
      time: 'Time of battery use:',
      return: 'Return:',
      reserve: 'Reserve:',
      payment: 'Payment:',
      refund: ' (refunded)',
      refund_2: ' refunded',
      close: 'CLOSE',
      history_link: 'For more information, access the ',
      return_back_place: 'Returned place',
      usage_time: 'Usage time',
      charged_back_value: 'Charged back value',
      payed_value: 'Payed value',
      free_transaction: 'Free transaction',
      take: 'Pick up:',
      rating: 'Rating:',
      no_rating: 'No rating',
      with_customer: 'Battery with customer',
      free_signature: 'Free by signature',
      credit_card: 'Credit card ending: {number}',
      pix: 'PIX',
      deposit: 'deposit and'
    },
    time: {
      day: 'day',
      days: 'days',
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes',
      second: 'second',
      seconds: 'seconds'
    },
    chatbot: {
      greeting:
        "Hello! 👋 I'm the Energy2Go virtual assistant. How can I help?\nIf you want to talk to a human assistant, just ask or click here: https://wa.me/5521998445033?text=Hi!%20I%20need%20help%20-%20E2G",
      error_message:
        'Error connecting to the assistant. Please try again in a few moments or human support via whatsapp: https://wa.me/5521998445033?text=Hi!%20I%20need%20help%20-%20E2G'
    }
  },
  pt: {
    common: {
      close: 'Fechar',
      saving: 'Salvando...',
      cancel: 'Cancelar',
      secure: 'Seguro',
      withdraw: 'Retirada de Bateria',
      rental: 'Aluguel Ativo',
      checkout: 'Checkout',
      summary: 'Resumo',
      protected: 'Protegido',
      secure_payment: 'Pagamento Seguro',
      back: 'Voltar',
      change: 'Alterar'
    },
    menu: {
      toggle: 'Alternar menu'
    },
    confirm_account: {
      welcome: 'Confirmação de conta',
      waiting: 'Verificando conta...',
      confirmation_successful: 'Sua conta foi confirmada com sucesso',
      confirmation_failed: 'Ocorreu um erro ao confirmar a sua conta',
      unspected_error: 'Ocorreu um erro inesperado'
    },
    login: {
      battery_almost_over: 'BATERIA QUASE ACABANDO?!',
      fast_login: 'FAÇA LOGIN PARA RETIRADA RÁPIDA',
      or: 'OU',
      create_account: 'CRIAR UMA CONTA NOVA',
      sign_in_or_create: 'Entrar ou Criar Conta',
      sign_in: 'Entre na sua conta',
      sign_in_button: 'Entrar',
      email_address: 'Email',
      password: 'Senha',
      forgot_password: 'Esqueceu a senha?',
      dont_have_account: 'Ainda não tem uma conta?',
      register_email: 'Cadastrar com email',
      register_social: 'Cadastrar com rede social',
      register_with_email: 'Acessar pelo email',
      login_with_code: 'Já possui o código? ',
      click_here: 'Clique aqui',
      facebook_btn_text: 'Continuar com o Facebook',
      locale: 'pt_BR',
      whatsapp_msg: 'https://api.whatsapp.com/send/?phone=5521998445033&text=Oi!%20Preciso%20de%20ajuda%20-%20E2G',
      find_us: 'Encontre outros pontos',
      title_rent: 'ALUGUE UM CARREGADOR PORTÁTIL',
      verify_mail:
        '*Verifique sua caixa de entrada do email para ver se o código foi enviado. Se não encontrado, verifique a pasta de spam.',
      validate: 'Validar',
      resend_email: 'Reenviar email',
      rent_info: 'Alugue{pointName} e devolva em qualquer estação Energy2Go.',
      rent_info_free_hourly_daily: 'Alugue{pointName} com {freeTime} grátis. Devolva em qualquer estação Energy2Go.',
      rent_info_hourly_daily:
        'Alugue{pointName}: primeiras {hourlyTime} por {hourlyPrice}. Devolva em qualquer estação Energy2Go.',
      rent_info_free_daily: 'Alugue{pointName} com {freeTime} grátis. Devolva em qualquer estação Energy2Go.',
      rent_info_daily: 'Alugue{pointName}: diária de {dailyPrice} (24h). Devolva em qualquer estação Energy2Go.',
      rent_info_free_hourly: 'Alugue{pointName} com {freeTime} grátis. Devolva em qualquer estação Energy2Go.',
      rent_info_hourly:
        'Alugue{pointName}: primeiras {hourlyTime} por {hourlyPrice}. Devolva em qualquer estação Energy2Go.'
    },
    sign_up: {
      submit: 'Acessar',
      sign_up: 'Acessar por email',
      email_address: 'Email',
      type_email: 'Digite seu e-mail',
      password: 'Senha',
      password_confirmation: 'Confirme a senha',
      agree_user_terms: 'Concordo com os termos de uso',
      user_terms: 'Termos de uso',
      already_have_account: 'Já tem uma conta?',
      already_have_social_account: 'Cadastrar com rede social',
      mandatory_user_terms: 'Você deve concordar com os termos de uso',
      password_doesnt_match: 'As senhas não conferem',
      invalid_email: 'Email inválido',
      required_email: 'Email obrigatório',
      email_verification: 'Verifique seu email para acessar sua conta. Se não encontrado, verifique a pasta de spam.',
      title_open_mail_modal: 'Validação'
    },
    forgot_password: {
      forgot_password: 'Esqueceu a senha?',
      email: 'Email',
      remember: 'Enviar',
      success: 'Enviamos um email com um link para você redefinir sua senha',
      failed: 'Não encontramos nenhum usuário com este email',
      redirect_msg: 'Você será redirecionado para a página de login em 5 segundos',
      invalid_email: 'Email inválido',
      required_email: 'Email obrigatório'
    },
    map: {
      place_open: 'Aberto',
      place_closed: 'Fechado',
      available_bateries: 'baterias disponíveis',
      available_slots: 'vagas disponíveis',
      close_hour: 'Fecha às',
      open_hour: 'Abre às',
      hour: 'em',
      my_location: 'Minha Localização',
      phone: 'SMARTPHONE',
      ebike: 'E-BIKE',
      all: 'TODOS',
      terminal_type: 'Terminais para: '
    },
    map_navigation: {
      title: 'Pontos de Troca',
      close: 'Fechar',
      back: 'Voltar',
      withdraw_battery: 'Retirar Bateria',
      select_station: 'Selecionar Terminal',
      select_terminal: 'Selecionar Terminal',
      available_batteries: 'baterias disponíveis',
      available_slots: 'vagas disponíveis',
      available_slots_return: 'slots disponíveis para devolução',
      location_denied: 'Permissão de localização negada',
      loading: 'Carregando mapa...',
      terminal_token: 'Token do Terminal',
      scan_qr_code: 'Escanear QR Code',
      check_prices: 'Consultar Preços',
      low_stock: 'Estoque baixo',
      copied: 'Copiado!',
      no_batteries: 'Sem baterias disponíveis',
      error_title: 'Erro ao carregar mapa',
      error_message: 'Ocorreu um problema ao carregar os pontos de coleta.',
      retry: 'Tentar novamente',
      no_points: 'Nenhum ponto disponível',
      no_points_message: 'Não há pontos de coleta disponíveis nesta região.',
      location_modal_title: 'Ativar Acesso à Localização',
      location_modal_description:
        'Precisamos de sua localização para melhorar a navegação e mostrar os terminais mais próximos de você.',
      location_modal_subtitle:
        'Sua privacidade é importante. Usamos sua localização apenas para melhorar sua experiência.',
      location_modal_allow: 'Permitir Acesso à Localização',
      location_modal_skip: 'Pular por Enquanto',
      permission_blocked_title: 'Permissão de Localização Bloqueada',
      permission_blocked_description:
        'Você negou o acesso à localização várias vezes. Para ativar novamente, você precisa resetar a permissão nas configurações do seu navegador.',
      permission_blocked_instructions:
        'Clique no ícone de cadeado ao lado da barra de endereço, procure por "Localização" e mude de "Bloquear" para "Perguntar".',
      permission_blocked_ok: 'Entendi',
      manual_token_title: 'Alugar bateria com código',
      manual_token_description: 'Digite o código de 4 dígitos localizado próximo do QR Code.',
      token_placeholder: '####',
      token_invalid_length: 'O token deve ter 4 caracteres',
      token_not_found: 'Token não encontrado. Por favor, verifique e tente novamente.',
      no_batteries_available: 'Este terminal não possui baterias disponíveis',
      station_name: 'Estação',
      address: 'Endereço',
      terminal_offline: 'Terminal Offline',
      retry_location: 'Ativar Localização',
      minimize: 'Minimizar',
      show_token_input: 'Mostrar Entrada de Token',
      manual_token_input: 'Digitar código',
      enter_token: 'Digitar Token',
      enter_token_manually: 'Digitar Token Manualmente',
      far_from_terminal_title: 'Você está a {distance} km de distância deste terminal',
      far_from_terminal_confirm: 'Tem certeza que deseja continuar?',
      continue: 'Continuar',
      cancel: 'Cancelar',
      return_battery: 'Devolver Bateria',
      return_here: 'Devolver Aqui',
      rent_here: 'Alugue aqui',
      no_slots: 'Sem slots disponíveis',
      validation_error_title: 'Escolha o terminal novamente',
      validation_error_close: 'Fechar',
      validation_error_terminal_info: 'Informações do Terminal',
      validation_error_available_cables: 'Tipos de Cabo Disponíveis Neste Terminal',
      validation_error_try_different_cable: 'Selecionar Outro Tipo de Cabo',
      validation_error_generic: 'Erro ao validar terminal',
      validation_timeout: 'Tempo limite de validação excedido - tente novamente',
      payment_error_title: 'Erro de Pagamento',
      payment_error_message:
        'Ocorreu um erro ao processar seu pagamento. Tente novamente ou selecione outro método de pagamento.',
      terminal_selection_error: 'Não foi possível selecionar o terminal. Tente novamente.',
      generic_error_message: 'Ocorreu um erro inesperado. Tente novamente.',
      error_terminal_offline_title: 'Terminal Offline',
      error_terminal_offline_message:
        'Este terminal está temporariamente offline. Por favor, tente novamente em alguns instantes ou selecione outro terminal.',
      error_retry: 'Tentar Novamente',
      error_choose_another: 'Escolher Outro Terminal',
      error_back_to_token: 'Voltar para Digitar Código',
      error_choose_another_battery: 'Escolher Outra Bateria',
      error_choose_another_pay: 'Escolher Outra Forma de Pagamento',
      error_no_cable_title: 'Cabo Não Disponível',
      error_no_cable_message:
        'Por favor, selecione um cabo disponível entre as opções abaixo ou devolva uma bateria com cabo antes de realizar outra retirada.',
      error_no_charged_title: 'Sem Baterias Carregadas',
      error_no_charged_message: 'Este terminal não possui baterias com carga completa no momento.',
      error_transaction_expired: 'O tempo limite expirou.',
      error_retry: 'Tentar Novamente',
      error_back_to_map: 'Voltar ao Mapa',
      address_not_available: 'Endereço não disponível',
      error_nearby_terminals_title: 'Terminais Próximos com Baterias',
      error_nearby_terminal_distance: '{distance}m de distância',
      error_select_terminal: 'Selecionar Este Terminal',
      error_validating_token: 'Erro ao validar o token',
      cable_switch_title: 'Escolha Outro Cabo',
      cable_switch_message:
        'Este terminal possui baterias disponíveis com diferentes tipos de cabo. Basta selecionar aquele que serve no seu aparelho!',
      select_cable: 'Selecione o tipo de cabo:',
      select_cable_to_continue: 'Selecione o tipo de cabo:',
      confirm_cable_selection: 'Confirmar Seleção',
      validating: 'Validando...',
      payment_verification: 'Verificação de Pagamento',
      payment_error_message:
        'Ocorreu um erro ao processar seu pagamento. Tente novamente ou selecione outro método de pagamento.',
      checking_payment: 'Verificando método de pagamento',
      validating_terminal: 'Validando terminal e verificando disponibilidade',
      checkout: 'Finalizar Checkout',
      checkout_verify_title: 'Confira o valor do aluguel e as condições',
      waiting_gps_signal: 'Buscando sinal de GPS...',
      gps_acquired: 'Localização encontrada',
      center_on_me: 'Centralizar na minha localização',
      my_location: 'Minha Localização',
      locating_gps: 'Buscando localização...',
      enable_location: 'Ativar localização',
      refresh_points: 'Atualizar pontos'
    },
    select_payment_method: {
      title: 'Escolha o Método de Pagamento',
      subtitle: 'Selecione a forma de pagamento que deseja utilizar:',
      choose_method: 'Escolha sua forma de pagamento',
      pix_description: 'Instantâneo e seguro',
      card_title: 'Cartão de Crédito',
      card_description: 'Prático e seguro',
      type_1: 'Cartão de crédito',
      type_2: 'PIX',
      back: 'VOLTAR',
      register: 'CADASTRAR',
      register_credit_card: 'CARTÃO DE CRÉDITO',
      register_pix: 'CADASTRAR PIX',
      deposit: 'Será cobrado um caução de',
      credit: '(crédito)',
      change: 'Modificar forma de pagamento já cadastrada:',
      modify: 'MODIFICAR'
    },
    checkout: {
      summary_title: 'Resumo da Transação',
      point: 'Estação',
      cable: 'Cabo',
      amount: 'Valor',
      payment_method: 'Pagamento',
      pix_scan_or_copy: 'Escaneie o QR Code ou copie a chave PIX',
      generating_qr_code: 'Gerando QR Code...',
      pix_copy_paste_key: 'PIX Copia e Cola',
      waiting_payment: 'Aguardando confirmação do pagamento...',
      card_will_be_charged: 'A cobrança será feita no seu cartão de crédito',
      processing: 'Processando...',
      confirm_payment: 'Confirmar Pagamento',
      credit_card: 'Cartão de Crédito',
      pricing_simulation: 'Simulação de Cobrança',
      view_other_prices: 'Ver outros preços',
      amount_to_pay: 'Valor a pagar',
      for_period: 'por {period}',
      pix_error_generating: 'Erro ao gerar QR Code do PIX. Por favor, tente novamente.',
      pix_important_info: 'Informação Importante',
      pix_return_to_website: 'Efetue o pagamento e retorne aqui para proseguir com o aluguel',
      deposit: 'Caução',
      deposit_title: 'Caução de Garantia',
      deposit_message:
        'Uma caução de R$ 99,90 será retida como garantia enquanto você estiver com a bateria. Esta será devolvida na próxima entrega.',
      deposit_agreement: 'Concordo com a caução',
      deposit_agreement_required: 'Você deve aceitar a caução para continuar',
      find_return_points: 'Veja no mapa os pontos de devolução',
      payment_confirmed: 'Pagamento Confirmado!',
      confirm_withdrawal: 'Confirmar Retirada',
      confirm_free_withdrawal: 'CONFIRMAR RETIRADA GRÁTIS*',
      confirm_withdrawal_without_free_time: 'CONFIRMAR RETIRADA SEM GRATUIDADE*',
      take_battery: 'Retirar Bateria',
      pix_generation_info: 'Para pagar com PIX, é necessário gerar um QR Code.',
      pix_registration_required: 'Para pagar com PIX, é necessário cadastrar seu Nome e CPF/CNPJ.',
      register_pix: 'Cadastrar dados do PIX',
      pix_expiring_soon: 'O QR Code expira em instantes',
      pix_expiring_warning: 'O QR Code expira em breve',
      pix_expires_in: 'Seu PIX expira em',
      pix_qr_expired: 'QR Code expirado',
      pix_qr_expired_message: 'O tempo para pagamento expirou. Gere um novo QR Code para continuar.',
      pix_generate_new_qr: 'Gerar novo QR Code',
      promo_benefit_badge: '*Benefício Promocional',
      promo_free_activated: 'Tempo grátis ativado',
      promo_not_activated: 'Tempo grátis desativado',
      promo_asterisk_note: '*Requisito obrigatório para aplicar a gratuidade (Grátis*) exibida acima.'
    },
    home: {
      take: {
        add_card: 'CADASTRAR SEU CARTÃO',
        no_charge: 'Cadastre um cartão de crédito válido para alugar. Seu cartão será armazenado pela Cielo.',
        ssl: 'Conexão segura',
        card_number: 'Número do Cartão',
        valid_through: 'Validade',
        name: 'Nome no cartão',
        save_credit_card: 'SALVAR DADOS DO CARTÃO',
        take_title: 'Selecione o tipo de cabo',
        cable_type: 'Escolha o Tipo de Cabo',
        qr_code_title_1: 'Selecione o Terminal Energy2go',
        qr_code_title_2: 'Localize o QR Code no terminal',
        qr_code_text: 'Escaneie os 4 digitos abaixo do QR code localizado na frente do terminal:',
        scan_qr: 'Escanear',
        scan_qr2: 'QR code',
        type_token: 'Ou digite o código de 4 dígitos abaixo do QR Code na frente do terminal:',
        terminal_token: '####',
        take_battery: 'Retirar Bateria',
        agreed: 'Ao alugar uma bateria portátil você concorda com os valores praticados: ',
        price_table: 'Consultar os preços',
        credit_cards: 'CARTÕES DE CRÉDITO',
        manage: 'Gerencie seus métodos de pagamento',
        standard: 'Padrão',
        delete: '',
        delete_title: 'Excluir Cartão de Crédito',
        delete_text: 'Excluir cartão terminando em ',
        delete_cable_title: 'Excluir Cabo',
        cancel: 'CANCELAR',
        confirm: 'RETIRAR BATERIA',
        checkout: 'OK',
        need_help: 'Contate-nos para eventos',
        selected_card: 'Você selecionou o cartão',
        standard_title: 'Cartão de Crédito Padrão',
        standard_text: 'Definir como padrão o cartão de crédito terminando em ',
        set_standart_credit_card_not_possible:
          'Ocorreu um erro ao atualizar o método de pagamento padrão. Tente novamente',
        slot: 'EMPURRE, depois PUXE a bateria indicada pelo LED piscante',
        charger: 'O App do Carregador deve estar indicando que a bateria está pronta para uso',
        verify_terminal: 'Verificando Terminal',
        register_card: 'Cadastrando Cartão de Crédito',
        liberate_battery: 'LIBERAR BATERIA',
        credit_reservation_1: 'Será efetuada uma reserva de ',
        credit_reservation:
          'Será efetuada uma reserva de saldo em seu cartão de acordo com a tabela de preços. Se a bateria não for retirada, a reserva será automaticamente cancelada.',
        dont_ask: 'Não perguntar novamente',
        campaign: '*Quero meu tempo grátis (aceito receber novidades do patrocinador)',
        no_free: 'Alugar sem o tempo gratuito patrocinado',
        update: 'Atualizando Permissões',
        on_demand: 'ALUGAR SOB DEMANDA',
        subscription: 'PLANOS DE ASSINATURA',
        understand: 'ENTENDI',
        free_time_title: 'Próxima Locação',
        free: 'grátis',
        sponsored_by: 'Patrocinado Por',
        at: 'em',
        only_at: 'Para acessar todos os Locais do Terminal, ',
        click_here: 'clique aqui!',
        other_terminals: 'Encontre outros terminais',
        logout: 'Sair',
        history: 'Histórico',
        logout_2: 'SAIR',
        payment_methods: 'Meios de Pagamento',
        home: 'Início',
        renew: 'Renovar ',
        events: 'ENTRE EM CONTATO CONOSCO PARA EVENTOS',
        maps_menu: 'Mapa de Pontos',
        here: 'aqui',
        table_footnote:
          '*O aluguel é para apenas uma bateria portátil e sua carga pode não durar por todo o período do aluguel.',
        table_footnote_2_1: '** Para pagamentos via PIX é necessário um caução de ',
        table_footnote_2_2: 'reais, após a devolução, o valor é devolvido parcialmente de acordo com os preços acima.',
        by: ' por ',
        table_title: 'Valores Cobrados',
        of: ' de ',
        text_table_redraw: 'Retire sua bateria portátil* em:',
        text_table_parks: 'Parques, Estádios, Bossa Nova Mall e Balneário Shopping:',
        text_table_charges_only: '- São cobradas apenas ',
        text_table_other_locations: 'Demais pontos:',
        text_table_ischarged: '- É cobrado ',
        text_table_stay: ' de permanência com a bateria',
        text_table_after_period: ', após este período são cobradas ',
        feedback_thanks: 'OBRIGADA PELA REPOSTA!',
        close: 'Fechar',
        send: 'ENVIAR',
        skip: 'PULAR',
        what_happened: 'O que aconteceu?',
        customer_response_1: 'Não soube qual bateria retirar.',
        customer_response_2: 'Tentei puxar, mas a bateria não saiu.',
        customer_response_3: 'Desisti de retirar a bateria',
        battery_not_removed: 'Bateria não foi removida.',
        inform_token: 'Token deve ser informado.',
        token_contain: 'Token deve conter apenas números ou apenas letras.',
        token_size: 'Token deve conter 4 números ou letras.',
        qr_scan_fail: 'Token não encontrado, escanear novamente ou informar o token manualmente.',
        qr_scan_fail_backend: 'Token nulo, leitura do qrcode falhou',
        user_card: 'Cartão de Crédito',
        card_ending: 'Final',
        terminal_offline_title: 'TERMINAL OFFLINE',
        terminal_offline_text: 'O terminal está offline, a bateria não pode ser retirada.',
        error_procession: 'Você recusou a reserva de crédito, bateria não retirada',
        confirm_cancel_operation: 'Deseja mesmo cancelar esta operação?',
        user_cancelled_transaction: 'Usuário cancelou a transação',
        fail_take_battery: 'Falha ao retirar bateria',
        transaction_failed: 'Transação falhou',
        fail_verify_terminal: 'Falha ao verificar terminal',
        fail_server_communication: 'Falha ao se comunicar com o servidor'
      },
      demonstration: {
        title: 'Retire a bateria',
        text_1: 'PUXE',
        text_2: ' a bateria conforme a figura.',
        error_slot_missing: 'Informação do slot não disponível. Tente novamente.',
        error_slot_invalid: 'Número do slot inválido. Tente novamente.'
      },
      return: {
        success: 'Intruções de uso',
        fail_title: 'BATERIA NÃO RETIRADA',
        fail_text: 'A bateria não foi retirada.',
        instructions: 'Solte os cabos e aperte o botão para carregar',
        free_time: 'Tempo Gratuito Restante',
        free_time_over: 'Seu tempo gratuito acabou! Por favor, devolva a bateria em qualquer um de nossos terminais.',
        time: 'Tempo usando a bateria',
        price: 'Preço Atual',
        check_out: 'Quero ver a ',
        map_1: 'Veja no',
        link_map: 'Mapa',
        map_2: ' os pontos para devolução',
        price_table: 'Tabela de Preços',
        error_title: 'Erro',
        error_message: 'Ocorreu um erro durante a transação.',
        faqs: {
          title: 'Precisa de ajuda?',
          were_to_return: {
            title: 'Onde posso devolver a bateria?',
            html_1: 'Veja',
            html_2: 'os pontos disponíveis',
            html_3: 'e a disponibilidade de slots vazios para devolução.'
          },
          not_charge: {
            title: 'Bateria não carrega',
            step_1: 'Verifique se o cabo da bateria esta conectado corretamente ao dispositivo.',
            step_2: 'Pressione o botão na parte inferior da bateria para forçar a carga da bateria.',
            step_3: 'Você pode devolver a bateria em menos de 5 minutos para receber o reembolso automaticamente.',
            step_4: 'Caso tenha outra bateria, faça outro aluguel, pois essa bateria será ignorada no próximo aluguel.'
          },

          how_to_return: {
            title: 'Como devolver a bateria?',
            step_1: 'Guarde os conectores de volta nas laterais da bateria.',
            step_2: 'Insira a bateria com a logo virada para cima em qualquer slot do totem até que ela trave.',
            step_3: 'Verifique se a bateria está bem travada.',
            step_4: 'Aguarde a luz azul do slot acender.',
            step_5: 'O site atualizará e a transação será encerrada.'
          },
          return_failed: {
            title: 'Devolvi, mas a transação não encerrou',
            html_1: 'Se a transação não encerrou, por favor, entre em contato conosco pelo: ',
            html_2: 'https://api.whatsapp.com/send/?phone=5521998445033&text=Oi!%20Preciso%20de%20ajuda%20-%20E2G',
            html_3: 'WhatsApp'
          }
        }
      }
    },
    history: {
      back: 'Voltar',
      rent: 'Histórico de Aluguéis',
      subtitle: 'Acompanhe suas retiradas e devoluções',
      summary: '{count} aluguéis encontrados',
      transaction: 'Aluguel',
      status_pending: 'Em andamento',
      status_completed: 'Concluído',
      taken_at: 'Retirada',
      returned_at: 'Devolução',
      pending_return: 'Devolução pendente',
      plan: 'Plano: ',
      load_more: 'Carregar Mais',
      no_transactions: 'Nenhuma transação encontrada ainda',
      empty_hint: 'Quando você fizer um aluguel, ele aparecerá aqui.',

      // Status de transação
      status_2: 'Reservado',
      status_15: 'Desconhecido',
      status_17: 'Devolvida Destrancada',
      status_19: 'Validada',

      // Status de pagamento
      payment_status_1: 'Pagamento Pendente',
      payment_status_2: 'Autorizado',
      payment_status_3: 'Capturado',
      payment_status_4: 'Pagamento Concluído',
      payment_status_5: 'Pagamento Falhou',
      payment_status_6: 'Estornado',
      payment_status_7: 'Cancelado',

      // Status de pré-pagamento
      pre_payment_status_1: 'Pré-pagamento Pendente',
      pre_payment_status_2: 'Aprovado',
      pre_payment_status_3: 'Processando',
      pre_payment_status_4: 'Pré-pagamento Falhou',
      pre_payment_status_5: 'Pré-pagamento Cancelado',
      pre_payment_status_6: 'Estornado',
      pre_payment_status_11: 'Autorizado',

      // Informações de estorno
      refund_info: 'Informações de Estorno',
      deposit_held: 'Caução de Segurança',
      amount_charged: 'Valor Cobrado',
      amount_refunded: 'Valor Estornado',
      refunded_badge: 'Estornado',
      status_timeline: 'Linha do Tempo',
      transaction_history: 'Histórico da Transação'
    },
    price_table: {
      title: 'Consulta de preços',
      title_2: ' no terminal',
      text: 'Retire a sua bateria por:',
      text_2: 'Durante o tempo que a bateria estiver com você, serão cobradas diárias de',
      text_3: ' até o limite de ',
      text_4: 'Caução no PIX (garantia) ',
      text_4_2: 'Caução (garantia):',
      text_5: 'será aplicado como garantia enquanto você estiver com a bateria.',
      text_6: 'para ver as informações de cobrança específicas do ponto.',
      until: 'Até',
      first: 'primeiros',
      campaign_first_hours: 'Campanha primeiras',
      campaign_first_minutes: 'Campanha primeiros',
      after_free: 'Próximas {duration}',
      first_period: 'Primeiras {duration}',
      after_hourly: 'Após isso (diária 24h)',
      after_free_daily: 'Após isso (diária 24h)',
      daily_only: 'Diária (24h)',
      hours: 'h',
      minutes: 'minutos',
      minutes_short: 'min',
      link: 'Selecione um terminal Energy2Go ',
      back: 'VOLTAR',
      warning: 'Faça o login e selecione um ponto Energy2Go ',
      free: 'Grátis*',
      free_star: 'Grátis*',
      help_text_find_token: 'Localize o QR Code na frente do terminal',
      help_text_digits: 'Insira os 4 digitos númericos abaixo',
      insert_token: 'token',
      token_not_found: 'Token digitado não encontrado. Verifique e tente novamente.',
      consult: 'CONSULTAR',
      new_consult: 'NOVA CONSULTA',
      obs1: 'Quantidade: Valor referente ao aluguel de 1 bateria portátil',
      obs2: 'Cobrança: Períodos e diárias são cobrados de forma integral (não há fração)',
      obs3: 'Autonomia: A carga da bateria pode não durar todo o período do aluguel',
      obs4: 'Promoção: Oferta patrocinada. Consulte as condições ao solicitar',
      obs5: 'Caução PIX: Trava de segurança de {deposit}, reembolsada após a devolução'
    },
    token_selection: {
      main_text: 'Local da Retirada',
      button_text: 'SELECIONAR',
      local: 'Local',
      current: 'Atual',
      address: 'Endereço',
      view_on_map: 'VER NO MAPA',
      view_map: 'VER MAPA',
      retry: 'RETENTATIVA',
      confirm: 'CONFIRMAR',
      back: 'VOLTAR',
      next_point: 'Estações Energy2Go mais próximas de você:',
      go_to_map: 'Outras Estações no mapa:',
      go_to_map_2: 'Ver todas as Estações da Rede Energy2Go',
      choose_other_terminal_1: 'Está alugando em outro local?',
      choose_other_terminal_2: 'Digitar outro token',
      choose_other_terminal: 'Alugando em outro local? Digite outro token',
      insert_token: 'ou insira os 4 dígitos manualmente:',
      generic_error: 'Não foi possível se comunicar com a estação. Por favor, tente novamente em instantes',
      proceed_text: 'Você selecionou a estação {token_input} localizado em: {newPointName}.',
      retry_same: 'Tentar novamente na mesma Estação Energy2go:',
      view_location: 'Ver localização no mapa',
      share_location_1: 'Compartilhe sua localização para aumentar a segurança do aluguel.',
      share_location_2: 'Toque para compartilhar.',
      qr_scanner_instruction: 'Aponte para o QRCode na parte de cima da estação para identificar o ponto para alugar',
      press_to_scan: 'Aperte para escanear >',
      location_distant_warning: 'Você parece estar distante da estação selecionada',
      qr_code_location_question: 'Onde fica o QR Code?',
      qr_code_location_title: 'Localização do QR Code',
      qr_code_location_description:
        'O QR Code está localizado na parte de cima da estação Energy2go. Aponte a câmera do seu celular para o código para identificar o ponto de aluguel.',
      qr_code_location_alt: 'Localização do QR Code na estação Energy2go',
      qr_code_image_unavailable: 'Imagem não disponível',
      touch_to_confirm: 'Toque para confirmar',
      touch_to_change: 'Toque para alterar',
      location_far: 'Você parece estar distante da estação {token_input}.'
    },
    rent_processing: {
      start: {
        text: 'Iniciando retirada de bateria'
      },
      verify: {
        text: 'Verificando estação de bateria'
      },
      cancel: {
        text: 'Aluguel cancelado pelo usuário, devido à distante do terminal',
        button: 'ENTENDI'
      },
      payment: {
        text: 'Processando transação'
      },
      error: {
        title: 'Erro',
        text: 'Erro ao retirar bateria'
      },
      campaign: {
        cancel_button: 'RETIRAR SEM GRATUIDADE',
        confirm_button: 'USAR TEMPO GRÁTIS'
      },
      confirmation: {
        text: 'Deseja confirmar a retirada da bateria com as opções abaixo?',
        cancel_confirmation: 'Tem certeza que deseja cancelar a retirada da bateria?',
        cancel: 'O valor do calção será estornado em 10 minutos ou menos'
      },
      pix_confirmation: {
        title: 'PAGAR COM PIX',
        text: 'Informações de pagamento',
        confirm: 'AVANÇAR',
        back: 'VOLTAR'
      },
      success: {
        text: 'Bateria retirada com sucesso'
      }
    },
    evaluation_box: {
      text: 'Obrigado pela resposta. Tente novamente',
      text_2: 'Obrigado pela resposta.'
    },
    evaluation_dialog: {
      success_title: 'Avaliação Enviada',
      success_message: 'Obrigado pelo seu feedback!',
      close_button: 'Fechar',
      question_what_problem: 'Qual foi o problema?',
      button_submit: 'Enviar Avaliação',
      button_cancel: 'Cancelar',
      submit_fail: 'Falha ao enviar avaliação'
    },
    failed_dialog: {
      title_battery_not_removed: 'A bateria não foi retirada',
      subtitle: 'Ocorreu um erro na retirada da bateria',
      automatic_refund_message: 'Reembolso automático em',
      automatic_refund: 'Tempo restante para reembolso automático',
      try_again: 'Tentar Novamente',
      refund: 'Solicitar Reembolso',
      skip: 'Pular',
      button_try_again: 'TENTAR NOVAMENTE',
      button_refund: 'Reembolsar',
      button_skip: 'Pular',
      message_retry_failed: 'Falha ao tentar novamente',
      message_refund_successful: 'Reembolso realizado com sucesso',
      message_refund_failed: 'Falha no reembolso',
      retry_fail: 'Falha na tentativa de repetição',
      refund_success: 'Reembolso realizado com sucesso',
      refund_fail: 'Falha no processo de reembolso, ocorrerá ao fim do tempo disponível.',
      refund_requested_title: 'Reembolso solicitado',
      refund_requested_message: 'Seu reembolso foi solicitado com sucesso e será processado em breve.',
      close_button: 'FECHAR',
      question_what_problem: 'Qual foi o problema?',
      subtitle_safe_balance: 'Não se preocupe, seu saldo está seguro.',
      button_refund_now: 'REEMBOLSAR AGORA',
      refund_confirmation_title: 'Confirmar Reembolso',
      refund_confirmation_message: 'Tem certeza que deseja solicitar o reembolso? Esta ação não pode ser desfeita.',
      button_confirm_refund: 'CONFIRMAR REEMBOLSO',
      button_cancel_refund: 'CANCELAR',
      automatic_refund_success_message: 'Reembolso solicitado automaticamente. O tempo expirou.'
    },
    refund_modal: {
      title_scheduled: 'Reembolso Agendado',
      title_completed: 'Reembolso Realizado',
      message_scheduled_pix:
        'O reembolso da sua caução via Pix foi agendado e será creditado na sua conta bancária de origem em breve.',
      message_completed_pix:
        'O estorno da caução via Pix foi concluído com sucesso e creditado na sua conta bancária de origem.',
      message_scheduled_card:
        'O cancelamento da reserva/estorno no cartão foi agendado e será processado pela sua operadora de cartão.',
      message_completed_card: 'O cancelamento da reserva/estorno no cartão de crédito foi confirmado com sucesso.',
      message_scheduled_generic:
        'Seu reembolso foi solicitado com sucesso e será processado de forma assíncrona em breve.',
      message_completed_generic: 'Seu reembolso foi realizado com sucesso.',
      automatic_notice: 'Reembolso solicitado automaticamente após o tempo limite de retirada.',
      async_notice: 'O estorno é realizado de forma assíncrona pelo sistema.',
      button_close: 'ENTENDI'
    },
    error_modal: {
      // Títulos e mensagens gerais
      generic_error_title: 'Erro inesperado',
      generic_error_message: 'Ocorreu um problema. Tente novamente ou entre em contato com o suporte.',
      validation_error_title: 'Erro de validação',
      validation_error_message: 'Os dados informados são inválidos. Verifique e tente novamente.',
      generic_hint: 'Algo deu errado.',

      // Erros específicos de terminal
      terminal_offline_title: 'Terminal offline',
      terminal_offline_message:
        'Este terminal está temporariamente indisponível. Tente novamente em alguns instantes ou selecione outro terminal.',

      // Erros de bateria/cabo
      no_cable_title: 'Cabo não disponível',
      no_cable_message: 'Não há baterias com o tipo de cabo selecionado neste terminal.',
      no_charged_title: 'Sem baterias carregadas',
      no_charged_message: 'Este terminal não possui baterias carregadas no momento.',

      // Erros de token
      invalid_token_title: 'QR Code inválido',
      invalid_token_message: 'O QR Code escaneado não é válido. Verifique se está escaneando o código correto.',
      terminal_not_found_title: 'Terminal não encontrado',
      terminal_not_found_message: 'O código digitado não corresponde a nenhum terminal.',

      // Erros de pagamento
      no_payment_title: 'Método de pagamento necessário',
      no_payment_message: 'É necessário cadastrar um método de pagamento para continuar.',

      // Erros de cadastro/login
      email_exists_title: 'Email já cadastrado',
      email_exists_message: 'Este email já está cadastrado em nossa plataforma.',
      invalid_code_title: 'Código de validação inválido',
      invalid_code_message: 'O código informado é inválido ou expirou.',

      // Ações/botões
      close: 'Fechar',
      try_again: 'Tentar novamente',
      scan_again: 'Escanear novamente',
      change_cable: 'Mudar tipo de cabo',
      select_another_terminal: 'Selecionar outro terminal',
      error_back_to_token: 'Voltar para Digitar Código',
      error_choose_another_battery: 'Escolher Outra Bateria',
      add_payment: 'Cadastrar pagamento',
      login: 'Fazer login',
      forgot_password: 'Esqueci minha senha',
      resend_code: 'Reenviar código',
      contact_support: 'Falar com suporte',

      // Seções auxiliares
      show_details: 'Mostrar detalhes',
      need_help: 'Precisa de ajuda?'
    },
    default_tile: {
      credit_card: {
        exclude: 'EXCLUIR'
      }
    },
    manage_payment: {
      title: 'Editar Formas de Pagamento',
      subtitle: 'Selecione ou adicione novas formas de pagamento',
      confirm_remove: 'Confirmar remover forma de pagamento?',
      removing: 'Removendo forma de pagamento...',
      dismiss: 'SELECIONAR',
      card: {
        title: 'Forma de pagamento: Crédito'
      },
      pix: {
        title: 'Forma de pagamento: PIX'
      },
      none: {
        title: 'Pagamento',
        subtitle: 'Formas de pagamento: PIX ou Crédito'
      },
      empty_state: 'Você ainda não possui meios de pagamento cadastrados.',
      disable_delete_rental_in_progress: 'Os métodos de pagamento não podem ser excluídos durante um aluguel ativo.'
    },
    credit_card_registration: {
      button: 'SALVAR DADOS DO CARTÃO',
      card_number: 'Número do Cartão',
      expiry_date: 'Data de Validade',
      cardholder_name: 'Nome do Titular',
      cardholder_name_placeholder: 'NOME NO CARTÃO',
      pix_registration: 'CADASTRAR PIX',
      errors: {
        number_required: 'Número do cartão é obrigatório',
        number_invalid: 'Número do cartão inválido',
        expiry_required: 'Data de validade é obrigatória',
        expiry_invalid: 'Data inválida',
        month_invalid: 'Mês inválido',
        card_expired: 'Cartão expirado',
        cvv_required: 'CVV é obrigatório',
        cvv_invalid: 'CVV inválido',
        name_required: 'Nome do titular é obrigatório',
        name_complete: 'Nome completo é obrigatório',
        register_error: 'Erro ao registrar cartão',
        register_error_retry: 'Erro ao registrar cartão. Tente novamente.'
      }
    },
    pix_payment: {
      title: 'PAGAR COM PIX',
      title_2: 'ADICIONAR SALDO',
      create_pix: 'GERAR QR CODE',
      create_pix_opt_in: '(COM TEMPO GRÁTIS)',
      create_pix_opt_out: '(SEM TEMPO GRÁTIS)',
      loading: 'Carregando QR Code para pagamento...',
      info: 'Não se preocupe! Você pagará apenas o valor do aluguel.',
      text_1: 'Será feito um pagamento de ',
      text_2: 'como garantia do aluguel (caução).',
      refund: 'O valor restante será reembolsado após a devolução da bateria, conforme a ',
      price_table: 'Tabela de Preços',
      warning: 'Efetue o pagamento e <b>retorne aqui</b> para prosseguir com o aluguel.',
      try_again: 'Tentar gerar QR Code novamente',
      change_payment: 'Mudar forma de pagamento',
      cancel: 'Cancelar',
      pre_price_table: 'Ver valores na ',
      post_price_table: ' após esse período',
      view_pix: 'Visualizar QR Code'
    },
    credit_card_payment: {
      title: 'Retirar Bateria',
      create_pix: 'RETIRAR BATERIA',
      create_pix_opt_in: '(COM TEMPO GRÁTIS)',
      create_pix_opt_out: '(SEM TEMPO GRÁTIS)',
      loading: 'Carregando QR Code para pagamento...',
      info: 'Não se preocupe! Você pagará apenas o valor do aluguel.',
      text_1: 'Será feito um pagamento de ',
      text_2: 'como garantia do aluguel (caução).',
      refund: 'O valor restante será reembolsado após a devolução da bateria, conforme a ',
      price_table: 'tabela de preços',
      warning: 'Efetue o pagamento e <b>retorne aqui</b> para prosseguir com o aluguel.',
      try_again: 'Tentar gerar QR Code novamente',
      change_payment: 'Mudar forma de pagamento',
      cancel: 'Cancelar',
      agree: 'Ao retirar a bateria você concordará com os valores na ',
      link_map: 'Precisa devolver em outro local? Veja os pontos no ',
      map: 'mapa',
      summary_title: 'Resumo & Valores',
      see_other_prices: 'ver outros preços',
      label_location: 'Local:',
      label_connector: 'Conector:',
      label_payment: 'Pagamento:',
      deposit_charge: 'Será cobrado {deposit} de caução',
      deposit_subtitle: 'Total ajustado automaticamente no final do aluguel.',
      confirm_with_free: 'CONFIRMAR RETIRADA',
      confirm_without_free: 'CONFIRMAR RETIRADA SEM TEMPO GRÁTIS',
      per_unit_hourly: 'por 4 horas',
      per_unit_daily: 'por dia',
      per_unit_battery: 'por bateria',
      payment_card: 'Cartão de Crédito',
      payment_pix: 'Pix',
      payment_not_applied: 'Pagamento não aplicado',
      payment_on_demand: 'Pagamento sob demanda',
      payment_unknown: 'Método de pagamento desconhecido',
      return_other_place: 'Precisa devolver em outro lugar? Ver pontos no ',
      map_link: 'mapa',
      free: 'grátis*',
      rental_value_label: 'VALOR DO ALUGUEL'
    },
    pix_registration: {
      title: 'CADASTRE SEUS DADOS PIX',
      subtitle: 'Cadastre seus dados Pix para poder realizar aluguéis',
      button: 'SALVAR DADOS PIX',
      back: 'VOLTAR',
      credit_card_registration: 'CADASTRAR CARTÃO DE CRÉDITO',
      full_name: 'Nome Completo',
      errors: {
        name_required: 'Campo Nome Completo é obrigatório',
        name_complete: 'Nome deve estar completo',
        cpf_cnpj_required: 'O campo CPF/CNPJ é obrigatório',
        cpf_invalid: 'CPF inválido',
        cnpj_invalid: 'CNPJ inválido',
        cpf_cnpj_invalid_length: 'CPF/CNPJ com tamanho inválido',
        register_error: 'Erro ao registrar identificação PIX',
        register_error_retry: 'Erro ao registrar identificação PIX. Tente novamente.'
      }
    },
    cable_type: {
      mini_box: {
        cable_title: '(já vem embutido)'
      },
      subtitle: 'Os cabos já vêm embutidos nas laterais da bateria',
      connector: 'SELECIONE O CONECTOR DO SEU DISPOSITIVO',
      options: {
        lightning: {
          labelName: 'Apple Lightning',
          labelLine: 'versão iPhone 14 e versões anteriores'
        },
        usbc: {
          labelName: 'USB-C',
          labelLine: 'dispositivos Android (ex.: Samsung, Motorola, Xiaomi), Apple iPhone 15 e versões posteriores'
        },
        micro: {
          labelName: 'Micro USB',
          labelLine: 'Android antigos, caixinhas de som e fones'
        }
      }
    },
    rating_transaction: {
      title: 'Avalie o aluguel da bateria em ',
      send: 'ENVIAR',
      feedback: 'Como foi a sua experiência? (opcional)'
    },
    transaction_info: {
      title: 'Bateria Devolvida com sucesso!',
      time: 'Tempo de uso da bateria:',
      return: 'Devolução:',
      reserve: 'Reserva:',
      payment: 'Pagamento:',
      refund: '(devolvido)',
      refund_2: ' devolvido',
      close: 'DISPENSAR',
      history_link: 'Para mais informações, acesse o ',
      return_back_place: 'Local da devolução',
      usage_time: 'Tempo de uso',
      charged_back_value: 'Valor devolvido',
      payed_value: 'Valor pago',
      free_transaction: 'Gratuito',
      take: 'Retirada:',
      rating: 'Classificação:',
      no_rating: 'Sem classificação',
      with_customer: 'Bateria com o cliente',
      free_signature: 'Grátis pela assinatura',
      credit_card: 'Cartão de crédito final: {number}',
      pix: 'PIX',
      deposit: 'calção e'
    },
    time: {
      day: 'dia',
      days: 'dias',
      hour: 'hora',
      hours: 'horas',
      minute: 'minuto',
      minutes: 'minutos',
      second: 'segundo',
      seconds: 'segundos'
    },
    chatbot: {
      greeting:
        'Olá! 👋 Sou o assistente virtual Energy2Go. Como posso ajudar?\nSe quiser falar com um assistente humano é só pedir ou clique aqui: https://wa.me/5521998445033?text=Oi!%20Preciso%20de%20ajuda%20-%20E2G',
      error_message:
        'Erro ao conectar com o assistente. Tente novamente em alguns instantes ou atendimento humano via whatsapp: https://wa.me/5521998445033?text=Oi!%20Preciso%20de%20ajuda%20-%20E2G'
    }
  }
}

const i18n = createI18n({
  locale: 'pt', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

export default i18n
